// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccessToggleController from "./access_toggle_controller";
application.register("access-toggle", AccessToggleController);

import AdvancedExportController from "./advanced_export_controller";
application.register("advanced-export", AdvancedExportController);

import AnalysisSelectorController from "./analysis_selector_controller";
application.register("analysis-selector", AnalysisSelectorController);

import ChartsController from "./charts_controller";
application.register("charts", ChartsController);

import DomainMenuController from "./domain_menu_controller";
application.register("domain-menu", DomainMenuController);

import EntitiesController from "./entities_controller";
application.register("entities", EntitiesController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import MissingVolumesController from "./missing_volumes_controller";
application.register("missing-volumes", MissingVolumesController);

import OutreachChartController from "./outreach_chart_controller";
application.register("outreach-chart", OutreachChartController);

import PasswordStrengthController from "./password_strength_controller";
application.register("password-strength", PasswordStrengthController);

import RedirectController from "./redirect_controller";
application.register("redirect", RedirectController);

import RefreshController from "./refresh_controller";
application.register("refresh", RefreshController);

import SignupModalController from "./signup_modal_controller";
application.register("signup-modal", SignupModalController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TurboRedirectController from "./turbo_redirect_controller";
application.register("turbo-redirect", TurboRedirectController);

import WizardEntriesController from "./wizard_entries_controller";
application.register("wizard-entries", WizardEntriesController);

import WizardTopicsController from "./wizard_topics_controller";
application.register("wizard-topics", WizardTopicsController);

import WorkflowProgressController from "./workflow_progress_controller";
application.register("workflow-progress", WorkflowProgressController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ResponseModalController from "./response_modal_controller";
application.register("response-modal", ResponseModalController);

import TopicEditorController from "./topic_editor_controller";
application.register("topic-editor", TopicEditorController);

import TopicManagerController from "./topic_manager_controller";
application.register("topic-manager", TopicManagerController);

import TopicFilterController from "./topic_filter_controller";
application.register("topic-filter", TopicFilterController);

import TopicKeywordsController from "./topic_keywords_controller";
application.register("topic-keywords", TopicKeywordsController);

import SchedulePreviewController from "./schedule_preview_controller";
application.register("schedule-preview", SchedulePreviewController);

import UrlsModalController from "./urls_modal_controller";
application.register("urls-modal", UrlsModalController);

import DomainFilterController from "./domain_filter_controller";
application.register("domain-filter", DomainFilterController);

import ProjectNameController from "./project_name_controller";
application.register("project-name", ProjectNameController);

import BrandRegexPreviewController from "./brand_regex_preview_controller";
application.register("brand-regex-preview", BrandRegexPreviewController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import ShowMoreController from "./show_more_controller";
application.register("show-more", ShowMoreController);
